
import { detectLocation } from './mappings/LocationMapping';
import { detectTravelConstraints } from './mappings/TravelDistanceMapping';
import { detectPriceConstraints } from './filters/PriceFilter';
import { detectFacilities } from './filters/FacilitiesFilter';
import { logDetectionSteps } from './utils/SearchOrchestration';
import { handleCoastaBravaSearch } from './strategies/CoastaBravaSearchStrategy';
import { handleTravelConstraintSearch } from './strategies/TravelConstraintSearchStrategy';
import { handleStandardSearch } from './strategies/StandardSearchStrategy';

export const performBasicSearch = async (query: string) => {
  try {
    console.log('🔍 === PERFORMING STRICT HIERARCHICAL SEARCH ===');
    console.log('Original query:', `"${query}"`);
    
    const searchTerms = query.toLowerCase().split(' ');
    console.log('Split search terms:', searchTerms);

    // ======= STEP 1-4: DETECTION PHASE =======
    const detectedLocation = detectLocation(searchTerms);
    const priceConstraints = detectPriceConstraints(searchTerms);
    const detectedFacilities = detectFacilities(searchTerms);
    const travelConstraints = detectTravelConstraints(searchTerms);
    
    console.log('🔍 === DETECTION RESULTS ===');
    console.log('Location detected:', detectedLocation);
    console.log('Price constraints detected:', priceConstraints);
    console.log('Facilities detected:', detectedFacilities);
    console.log('Travel constraints detected:', travelConstraints);
    
    logDetectionSteps(detectedLocation, priceConstraints, detectedFacilities);
    
    if (travelConstraints) {
      console.log('🛫 === TRAVEL CONSTRAINTS DETECTED ===');
      console.log('Travel constraints:', travelConstraints);
    }

    // Check for accommodation terms
    const hasAccommodationTerms = searchTerms.some(term => 
      term.includes('huis') || term.includes('appartement') || term.includes('hotel') || 
      term.includes('camping') || term.includes('resort') || term.includes('vakantie')
    );

    // STRICT FILTERING: If we have a location + accommodation, apply both strictly
    if (detectedLocation && hasAccommodationTerms) {
      console.log('🎯 === STRICT SEARCH MODE: Location + Accommodation detected ===');
      console.log('Will apply STRICT filtering - no broad search fallback');
      return await handleStandardSearch(searchTerms, detectedLocation, priceConstraints, detectedFacilities, travelConstraints, query);
    }

    // If we have travel constraints but no location, use travel constraints as primary filter
    if (travelConstraints && !detectedLocation) {
      console.log('🛫 Using travel constraints as primary filter (no location detected)');
      return await handleTravelConstraintSearch(travelConstraints, priceConstraints, detectedFacilities, query);
    }
    
    if (!detectedLocation && !travelConstraints) {
      console.log('❌ No location or travel constraints detected - cannot proceed with basic search');
      return [];
    }

    // Special handling for Costa Brava searches to get more results
    if (detectedLocation?.type === 'region' && detectedLocation.info.region === 'Costa Brava') {
      return await handleCoastaBravaSearch(detectedLocation, priceConstraints, detectedFacilities, travelConstraints, query);
    }

    // Standard search flow with STRICT filtering
    return await handleStandardSearch(searchTerms, detectedLocation, priceConstraints, detectedFacilities, travelConstraints, query);
    
  } catch (error: any) {
    console.error('💥 Strict hierarchical search error:', error);
    throw error;
  }
};
